'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mobxStateTree = require('mobx-state-tree');

var _ContentService = require('./ContentService');

var _ContentService2 = _interopRequireDefault(_ContentService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Here we define the structure that content entries in the store must
 * conform to. The content is the actual content data, and it is frozen
 * because we currently don't expect the data to change. isLoading is self
 * explanitory and lastUpdated is a string version of a date. It is currently
 * not used, but in future if we wish to implement caching or certain time
 * related rules it will come in handy. In addition to all this, we also have
 * two computed views, isStale and isReady - both of which are described in
 * more detail below.
 */
var ContentDataType = _mobxStateTree.types.model('contentData', {
	id: _mobxStateTree.types.string,
	content: _mobxStateTree.types.frozen,
	isLoading: _mobxStateTree.types.boolean
}).views(function (self) {
	return {
		/**
   * isStale returns whether the data is out of date, because we are not
   * using the lastUpdated date it currently only says data
   * is stale if it has not loaded yet (i.e. is still null). If we do
   * use lastUpdated this should be modified to accommodate.
   */
		get isStale() {
			return !self.content && !self.isLoading;
		},

		/**
   * isReady indicates whether the data is currently ready to access,
   * if the content is loaded and the content is not in the process of
   * loading then it is ready to consume.
   */
		get isReady() {
			return self.content && !self.isLoading;
		}
	};
});

var ContentStore = function () {
	function ContentStore(contentBaseUrl, contentAreaBaseUrl) {
		_classCallCheck(this, ContentStore);

		this._service = new _ContentService2.default(contentBaseUrl, contentAreaBaseUrl);
	}

	_createClass(ContentStore, [{
		key: 'create',
		value: function create() {
			var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ContentStore.defaultState;

			return this.store.create(defaultState);
		}
	}, {
		key: 'store',
		get: function get() {
			var service = this._service;
			return _mobxStateTree.types.model('ContentStore', {
				data: _mobxStateTree.types.array(ContentDataType)
			}).views(function (self) {
				return {
					getContentForIds: function getContentForIds(ids) {
						return ids.reduce(function (acc, id) {
							acc[id] = self.data.find(function (item) {
								return item.id === id;
							});
							return acc;
						}, {});
					},
					getFlattenedContentForIds: function getFlattenedContentForIds(ids) {
						var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

						return ids.reduce(function (acc, id) {
							var dataItem = self.data.find(function (item) {
								return item.id === id;
							});
							if (dataItem) {
								var map = maps.find(function (m) {
									return m.inject === id;
								});
								if (map) {
									acc[map.as] = dataItem.content;
								} else {
									acc[id] = dataItem.content;
								}
							}
							return acc;
						}, {});
					}
				};
			}).actions(function (self) {
				return {
					addContent: function addContent(id) {
						var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
						var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

						self.data.unshift({
							id: id,
							content: content,
							isLoading: loading
						});
					},


					/**
      * updateContent is used to update the value of a conten item in the store.
      * @param {String}            id          - id corresponding to the content we want to update
      * @param {ContentDataType}   content     - the content data we wish to populate it with
      */
					updateContent: function updateContent(id, content) {
						var item = self.data.find(function (item) {
							return item.id === id;
						});
						if (item) {
							item.content = content;
							item.isLoading = false;
						}
					},
					clearContent: function clearContent() {
						self.data = [];
					},


					/**
      * loadContent is used to ensure the content for the given
      * section id's are loaded, and if they are not loaded - will
      * fetch them. It looks through current state of the store
      * to see which sections are stale and which are not. If it is
      * stale we add the sectionID to another array indicating which
      * we sections we have to load and which we can just access normally.
      *
      * If there are any id's left to load, then we only resolve the promise when
      * all the new values are loaded and ready to access, otherwise we can just
      * resolve as all the id's are loaded.
      * @param {Array<String>} contentIds         - the array of section id's that are being requested
      * @param {Array<String>} contentAreaIds     - the array of content area id's that are being requested
      */
					loadContent: (0, _mobxStateTree.flow)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contentIds) {
						var contentAreaIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
						var needsUpdating, staleContentIds, staleContentAreaIds, syncRequests, responses;
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										// Allow null and handle it here in case developer only wants content areas
										// eg loadContent(null, ['myPageWithContentArea']);
										if (!contentIds) {
											contentIds = [];
										}

										needsUpdating = [];

										[].concat(_toConsumableArray(contentIds), _toConsumableArray(contentAreaIds)).forEach(function (id) {
											var datadItem = self.data.find(function (item) {
												return item.id === id;
											});

											if (!datadItem) {
												self.addContent(id, null, true);
												needsUpdating.push(id);
											} else if (datadItem.isStale) {
												datadItem.isLoading = true;
												needsUpdating.push(id);
											}
										});

										// Exit early if no work needs to be done

										if (needsUpdating.length) {
											_context.next = 5;
											break;
										}

										return _context.abrupt('return');

									case 5:
										staleContentIds = needsUpdating.filter(function (id) {
											return contentIds.includes(id);
										});
										staleContentAreaIds = needsUpdating.filter(function (id) {
											return contentAreaIds.includes(id);
										});
										syncRequests = [];


										if (staleContentAreaIds.length) {
											staleContentAreaIds.forEach(function (id) {
												syncRequests.push(service.getContentArea(id));
											});
										}

										if (staleContentIds.length) {
											syncRequests.push(service.getContent(staleContentIds));
										}

										_context.next = 12;
										return Promise.all(syncRequests);

									case 12:
										responses = _context.sent;


										responses.forEach(function (resp) {
											Object.keys(resp).forEach(function (contentKey) {
												self.updateContent(contentKey, resp[contentKey]);
											});
										});

									case 14:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, this);
					}))
				};
			});
		}
	}], [{
		key: 'defaultState',
		get: function get() {
			return {
				data: []
			};
		}
	}]);

	return ContentStore;
}();

var ContentStoreFactory = function () {
	function ContentStoreFactory() {
		_classCallCheck(this, ContentStoreFactory);
	}

	_createClass(ContentStoreFactory, null, [{
		key: 'createContentStore',
		value: function createContentStore(contentBaseUrl, contentAreaBaseUrl) {
			return new ContentStore(contentBaseUrl, contentAreaBaseUrl);
		}
	}]);

	return ContentStoreFactory;
}();

exports.default = ContentStoreFactory;
//# sourceMappingURL=ContentStoreFactory.js.map